import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import {
  updateContentCollection,
  updatePermissions,
  addReceivedDocument,
  removeReceivedDocument,
  setUserContentSettings,
} from '../actions'

import * as Content from '../reducers/Content'

class FirebaseListeners {
  constructor(firebase, reduxStore) {
    this.reduxStore = reduxStore
    this.firebase = firebase
  }

  startListening() {
    this.stopListeningToContentCollectionChanges = this.startListeningToContentCollectionChanges()
    this.stopListeningToPermissionsGiven = this.startListeningToPermissionsGiven()
    this.stopListeningToReceivedContentCollection = this.startListeningToReceivedContentCollection()
    this.stopListeningToUserContentSettings = this.startListeningToUserContentSettings()
  }

  stopListening() {
    if (this.stopListeningToContentCollectionChanges !== undefined) {
      this.stopListeningToContentCollectionChanges()
    }
    if (this.stopListeningToPermissionsGiven !== undefined) {
      this.stopListeningToPermissionsGiven()
    }
    if (this.stopListeningToReceivedContentCollection !== undefined) {
      this.stopListeningToReceivedContentCollection()
    }
    if (this.stopListeningToUserContentSettings !== undefined) {
      this.stopListeningToUserContentSettings()
    }
  }

  startListeningToContentCollectionChanges() {
    const { reduxStore } = this
    const userId = this.firebase.userId()
    return this.firebase.contentCollection().onSnapshot(function (documents) {
      const modified = {}
      const removed = []
      documents.docChanges().forEach(function (change) {
        const { doc } = change
        const contentId = doc.id
        if (change.type === 'removed') {
          removed.push(contentId)
        } else {
          const data = doc.data().content
          const content = data ? JSON.parse(data) : undefined
          if (content !== undefined) {
            content.contentId = contentId
            modified[`${userId}-${contentId}`] = Content.fixed(content)
          }
        }
      })

      reduxStore.dispatch(updateContentCollection(modified, removed))
    })
  }

  startListeningToReceivedContentCollection() {
    const { reduxStore } = this

    this.firebase
      .permissions()
      .where('recipient', '==', this.firebase.userEmail())
      .onSnapshot((docs) => {
        docs.docChanges().forEach((document) => {
          const contentDoc = document.doc.ref.parent.parent
          const ownerDoc = contentDoc.parent.parent
          if (['added'].includes(document.type)) {
            contentDoc.onSnapshot(
              (doc) => {
                const data = doc.data()
                if (data !== undefined) {
                  reduxStore.dispatch(
                    addReceivedDocument(
                      JSON.parse(doc.data().content),
                      ownerDoc.id,
                    ),
                  )
                }
              },
              (error) => {
                console.log(error)
              },
            )
          }

          if (document.type === 'removed') {
            const documentId = `${ownerDoc.id}-${contentDoc.id}`
            reduxStore.dispatch(removeReceivedDocument(documentId))
          }
        })
      })
  }

  startListeningToPermissionsGiven() {
    const { reduxStore } = this
    return this.firebase.permissionsGiven().onSnapshot(function (documents) {
      const recipients = []
      documents.forEach(function (permission) {
        const data = permission.data()
        const content = permission.ref.parent.parent
        const ownerDoc = content.parent.parent
        recipients.push({
          fullContentId: `${ownerDoc.id}-${content.id}`,
          contentId: content.id,
          ...data,
        })
      })
      reduxStore.dispatch(updatePermissions(recipients))
    })
  }

  startListeningToUserContentSettings() {
    const { reduxStore } = this
    return this.firebase
      .currentUser()
      .collection('settings')
      .doc('content')
      .onSnapshot((doc) => {
        reduxStore.dispatch(setUserContentSettings(doc.data()))
      })
  }
}

export default FirebaseListeners
